/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var ToggleOnIcon = createIcon({
  name: 'ToggleOnIcon',
  height: 512,
  width: 576,
  svgPath: 'M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default ToggleOnIcon;